<template>
  <q-dialog
    ref="dialog"
    full-width
    full-height
    @hide="onDialogHide"
  >
    <q-card class="q-dialog-plugin">
      <PDFViewer
        :source="url"
        style="height: 100vh; width: 100vw"
        @download="handleDownload"
      />
    </q-card>
  </q-dialog>
</template>

<script>
import api from '@/libs/api'
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'

const ipcRenderer = window.ipcRenderer

export default {
  components: {
    PDFViewer
  },

  props: {
    url: {}
  },

  methods: {
    show () {
      this.$refs.dialog.show()
    },

    hide () {
      this.$refs.dialog.hide()
    },

    async handleDownload ({ filename }) {
      const downloadUrl = await api.getDownloadUrl(this.url)
      if (!downloadUrl) return

      ipcRenderer.send('download', {
        payload: {
          url: downloadUrl,
          name: filename
        }
      })
    },

    onDialogHide () {
      this.$emit('hide')
    }
  }
}
</script>
